// Module
var code = "<section class=\"{{ ::$ctrl.customClass }}\"> <span ng-if=\"::$ctrl.lastChanged\" class=\"detail-item-heading\">{{ ::$ctrl.text.lastUpdated }} {{ ::$ctrl.model }}</span> <div ng-transclude></div> </section> ";
// Exports
export default code;